export const classesMessages = {
  resources: {
    classes: {
      name: "Class |||| Classes",
      forcedCaseName: "Class",
      fields: {
        name: "Class name",
        program_id: "Program",
        program_name: "Program",
        location: "Location",
        day_of_week: "Day",
        start_time: "Starts",
        end_time: "Ends",
        schedule: "Schedule",
        age_min: "Minimum age",
        age_max: "Maximum age",
        ages: "Ages",
        gender: "Group",
        capacity: "Capacity",
        price_cents: "Price ($)",
        coach_id: "Coach",
        coach_name: "Coach",
        acuity_appointment_type_id: "Acuity appointment type ID",
        acuity_calendar_id: "Acuity calendar ID",
        active: "Active",
        nb_enrolled: "Enrolled",
        spots_left: "Spots left",
        nb_waitlist: "Waitlist",
        nb_unpaid: "Unpaid",
      },
      field_categories: {
        details: "Details",
        schedule: "Schedule",
        audience: "Who it's for",
        acuity: "Acuity link",
      },
      days: {
        monday: "Monday",
        tuesday: "Tuesday",
        wednesday: "Wednesday",
        thursday: "Thursday",
        friday: "Friday",
        saturday: "Saturday",
        sunday: "Sunday",
      },
      genders: {
        mixed: "Mixed",
        sisters: "Sisters",
        brothers: "Brothers",
      },
      filters: {
        active_only: "Active only",
        show: "Show classes",
        active: "Active",
        all: "All",
      },
      action: {
        new: "New Class",
        create: "Create Class",
        edit: "Edit class",
        export_roster: "Export roster",
        add_player: "Add player",
      },
      inactive: "Inactive",
      acuity_helper:
        "Optional. Fill these in so Acuity bookings land in this class automatically.",
      empty: {
        title: "No classes yet",
        description: "Create a class to start building its roster.",
      },
      roster: {
        title: "Roster",
        enrolled: "Enrolled",
        spots_left: "Spots left",
        waitlist: "Waitlist",
        unpaid: "Unpaid",
        full: "Full",
        no_cap: "No cap",
        empty: "Nobody here yet.",
        stages: {
          registered: "Registered",
          trial: "Trial / drop-in",
          waitlist: "Waitlist",
        },
        columns: {
          player: "Player",
          age: "Age",
          gender: "Gender",
          guardian: "Guardian",
          phone: "Phone",
          paid: "Paid",
          source: "Source",
          notes: "Notes",
          actions: "Stage",
        },
        row_stages: {
          registered: "Registered",
          trial: "Trial / drop-in",
          waitlist: "Waitlist",
          lost: "Lost (remove)",
        },
        change_stage: "Change stage",
        stage_changed: "Moved to %{stage}",
        open_enrollment: "Open enrollment",
        paid: "Paid",
        medical: "Medical",
        coach: "Coach",
        export_empty: "This class has nobody on its roster yet.",
      },
    },
  },
};
